<template>
  <div class="editor-sub-info">
    <row
      class-name="editor-sub-info__row"
      :gutter="16"
      v-for="row in subInfoRows"
      :key="row.value"
      align="middle"
    >
      <i-col span="12">
        <span class="ms-text">{{ row.title }}</span>
      </i-col>
      <i-col
        span="12"
        :class="[
          'editor-sub-info__value',
          row.type === 'boolean' ? 'centered' : ''
        ]"
      >
        <i-input
          v-if="row.type === 'string'"
          v-model="contract[row.prop]"
          :placeholder="row.placeholder"
        />

        <i-select
          v-else-if="row.type === 'select' && row.selectType === 'single'"
          v-model="contract[row.prop]"
          clearable
        >
          <i-option
            v-for="item in values[row.value]"
            :value="item.id"
            :key="item.id"
          >
            {{ item.name }}
          </i-option>
        </i-select>

        <i-select
          v-else-if="row.type === 'select' && row.selectType === 'multi'"
          v-model="contract[row.prop]"
          clearable
          multiple
          :max-tag-count="2"
        >
          <i-option
            v-for="item in values[row.value]"
            :value="item.id"
            :key="item.id"
          >
            {{ item.name }}
          </i-option>
        </i-select>

        <div v-else-if="row.type === 'boolean'">
          <checkbox v-model="contract[row.prop]" />
        </div>

        <i-input
          v-else-if="row.type === 'textarea'"
          v-model="contract[row.prop]"
          type="textarea"
          placeholder=""
        />
      </i-col>
    </row>
  </div>
</template>

<script>
import { subInfoRows } from '@/config/contracts'

const requestingFields = subInfoRows.filter(
  ({ type, value }) => type === 'select'
)

export default {
  props: ['contract'],
  data () {
    return {
      values: {
        federal_districts: [],
        profile_work_regions: [],
        climate_conditions: [],
        project_stages: [],
        responsibility_levels: [],
        territory_types: [],
        offshore_drillings: []
      },
      loading: false,
      subInfoRows
    }
  },
  async created () {
    try {
      this.loading = true

      for (let i = 0; i < requestingFields.length; i++) {
        const { value } = requestingFields[i]

        this.values[value] = await this.$store.dispatch('GET_REQUEST', {
          url: `objectInfo/${value}`
        })
      }

      this.loading = false
    } catch (error) {
      console.log(error)
      this.loading = false
    }
  }
}
</script>

<style lang="less">
.editor-sub-info {
  &__row {
    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }

  &__value {
    display: flex;
    justify-content: center;
    &.centered {
      display: flex;
      justify-content: center;
    }
  }

  .ivu-select {
    width: 100%;
  }
}
</style>
